import { cmsAxios } from "./config/axiosConfig";

// 1. Fetch Libraries List
export const fetchLibrariesList = async () => {
  try {
    const response = await cmsAxios.get("/cms/libraries/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching libraries list:", error);
    throw error;
  }
};

interface Sip2LibraryConfig {
  sipPORT: number;
  sipSERVER: string;
  sipUsername: string;
  sipPassword: string;
  institutionId: string;
}

interface PatronApiLibraryConfig {
  port: number;
  hostname: string;
}

export type LibraryConfig = Sip2LibraryConfig | PatronApiLibraryConfig;

export interface LibraryPayload {
  name: string;
  contactEmail: string;
  libraryAuthTypeId: string;
  isActive: boolean;
  libraryConfig: LibraryConfig[];
}

export const createLibrary = async (payload: LibraryPayload) => {
  try {
    const response = await cmsAxios.post("/cms/libraries/create", payload);
    return response.data;
  } catch (error) {
    console.error("Error creating library:", error);
    throw error;
  }
};

// 3. Update Library Status
export const updateLibrary = async (
  libraryId: string,
  payload: LibraryPayload
) => {
  try {
    const response = await cmsAxios.put(`/cms/libraries/${libraryId}`, payload);
    return response.data;
  } catch (error) {
    console.error(`Error updating library ${libraryId}:`, error);
    throw error;
  }
};

export const fetchLibraryAuthTypes = async () => {
  try {
    const response = await cmsAxios.get("/cms/library-auth-type/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching auth types:", error);
    throw error;
  }
};
